import { IEquipmentTypes } from 'types/graphqlTypes'
import * as yup from 'yup'
import {
  EQUIPMENT_OPTIONS,
  EQUIPMENT_TYPE_OPTIONS,
} from 'apps/marketplace/utils/constants/graphqlEquipment'
import { REQUIRED_MESSAGE } from '../constants'
import { DryVanSchemaObject } from './EquipmentDryVanSchema'
import { OpenDeckSchemaObject } from './EquipmentOpenDeckSchema'
import { ReeferSchemaObject } from './EquipmentReeferSchema'
import { SpecializedEquipmentSchemaObject } from './EquipmentSpecializedSchema'

const EQUIPMENT_OPTION_VALUES = EQUIPMENT_OPTIONS.map(({ value }) => value)

const DRY_VAN_OPTIONS = EQUIPMENT_TYPE_OPTIONS.dry_van
const DRY_VAN_OPTIONS_VALUES = DRY_VAN_OPTIONS.map(({ value }) => value)

const REEFER_OPTIONS = EQUIPMENT_TYPE_OPTIONS.reefer
const REEFER_OPTIONS_VALUES = REEFER_OPTIONS.map(({ value }) => value)

const OPEN_DECK_OPTIONS = EQUIPMENT_TYPE_OPTIONS.open_deck
const OPEN_DECK_OPTIONS_VALUES = OPEN_DECK_OPTIONS.map(({ value }) => value)

export const EquipmentDetailsSchemaObject = {
  /**
   * @example 'dry_van'
   */
  equipment: yup
    .mixed<IEquipmentTypes>()
    .oneOf(EQUIPMENT_OPTION_VALUES, REQUIRED_MESSAGE)
    .required(REQUIRED_MESSAGE),
  /**
   * @example '_53_van'
   */
  equipmentType: yup
    .mixed<IEquipmentTypes>()
    .when('equipment', {
      is: IEquipmentTypes.dry_van,
      then: yup
        .mixed<IEquipmentTypes>()
        .oneOf(DRY_VAN_OPTIONS_VALUES, REQUIRED_MESSAGE)
        .required(REQUIRED_MESSAGE),
    })
    .when('equipment', {
      is: IEquipmentTypes.reefer,
      then: yup
        .mixed<IEquipmentTypes>()
        .oneOf(REEFER_OPTIONS_VALUES, REQUIRED_MESSAGE)
        .required(REQUIRED_MESSAGE),
    })
    .when('equipment', {
      is: IEquipmentTypes.open_deck,
      then: yup
        .mixed<IEquipmentTypes>()
        .oneOf(OPEN_DECK_OPTIONS_VALUES, REQUIRED_MESSAGE)
        .required(REQUIRED_MESSAGE),
    }),
  /**
   * @example: { equipmentAttributes: { precool: '40' } }
   */
  equipmentAttributes: yup
    .object()
    .when('equipment', {
      is: IEquipmentTypes.dry_van,
      then: yup.object(DryVanSchemaObject),
    })
    .when('equipment', {
      is: IEquipmentTypes.reefer,
      then: yup.object(ReeferSchemaObject),
    })
    .when('equipment', {
      is: IEquipmentTypes.open_deck,
      then: yup.object(OpenDeckSchemaObject),
    })
    .when('equipment', {
      is: IEquipmentTypes.specialized,
      then: yup.object(SpecializedEquipmentSchemaObject),
    }),
}

export const EquipmentDetailsSchema = yup.object(EquipmentDetailsSchemaObject)

export type TEquipmentDetailsSchema = yup.InferType<typeof EquipmentDetailsSchema>
